import { render, staticRenderFns } from "./DashboardAlbaranes.vue?vue&type=template&id=0106192a&scoped=true&lang=pug"
import script from "./DashboardAlbaranes.vue?vue&type=script&lang=js"
export * from "./DashboardAlbaranes.vue?vue&type=script&lang=js"
import style0 from "./DashboardAlbaranes.vue?vue&type=style&index=0&id=0106192a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0106192a",
  null
  
)

export default component.exports